import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { PreferencesContext } from '@common/contexts/preferences';
import { UIContext } from '@app/dev/contexts/ui';

export const SkinImage = ({
  path, fileType, isImg, ...rest
}) => {
  const [imageToRender, setImageToRender] = useState();
  const [{ lang }] = useContext(PreferencesContext);
  const [uiState] = useContext(UIContext);

  useEffect(() => {
    const loadImage = async () => {
      const imageParts = path.split('/');
      const imageNameAndFormat = imageParts[imageParts.length - 1];
      const [imageName] = imageNameAndFormat.split('.');
      const skinImagePath = `${path.replace(imageName, `${imageName}-${SKIN_SHORT_NAME}`)}`;
      const skinDarkImagePath = `${path.replace(imageName, `${imageName}-${SKIN_SHORT_NAME}-${uiState.theme}`)}`;

      let imageToSet;

      // Try loading in order of preference using Vite's glob import
      const images = import.meta.glob('@app/dev/images/**/*', { eager: false });

      const pathsToTry = [
        `/dev/images/${skinDarkImagePath}`,
        `/dev/images/${lang}/${skinImagePath}`,
        `/dev/images/${skinImagePath}`,
        `/dev/images/${path}`,
      ];

      for (const imagePath of pathsToTry) {
        const globKey = Object.keys(images).find(key => key === imagePath);

        if (globKey) {
          try {
            const imageModule = await images[globKey]();
            imageToSet = imageModule.default || imageModule;
            break;
          } catch (e) {
            // Try next path
          }
        }
      }

      if (imageToSet) {
        setImageToRender(imageToSet);
      }
    };

    loadImage();
  }, [lang, uiState.theme, path]);

  if (!imageToRender) return null;

  if (fileType === 'webm') {
    return (
      <video muted autoPlay loop>
        <source src={imageToRender.default || imageToRender} />
      </video>
    );
  }

  if (fileType === 'gif') return <img src={imageToRender.default || imageToRender} {...rest} />

  return (
    isImg ? (
      <img
        {...rest}
        src={imageToRender.default || imageToRender}
        alt=""
        style={{ ...rest.style }}
      />
    ) : (
      <div
        {...rest}
        style={{
          ...rest.style,
          backgroundImage: `url(${imageToRender.default || imageToRender})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
    ));
};

SkinImage.propTypes = {
  path: PropTypes.string,
  fileType: PropTypes.string,
  isImg: PropTypes.bool,
};
